import React, { useState, useEffect } from 'react';
import HeroSection from '../components/HeroSection';
import JoinAcm from '../components/JoinAcm';
import AboutAcmSection from '../components/AboutAcmSection';
import Popup from '../components/Popup';
import UpcomingEvents from '../components/UpcomingEvents';
import EventPosters from '../components/EventPosters';
import PastEvents from '../components/PastEvents';
import CtaSection from '../components/CtaSection';
import MarqueeText from '../components/MarqueeText';

const HomePage = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {

    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  return (
    <div>
      <HeroSection />
      <MarqueeText />
      <div style={{ paddingTop: '10px' }}> 
        <UpcomingEvents />
        <EventPosters />
        <PastEvents />
        <JoinAcm />
        <AboutAcmSection />
        <CtaSection />
      </div>
      {showPopup && <Popup onClose={handleClosePopup} />}
    </div>
  );
};

export default HomePage;
